module.exports = __webpack_public_path__ + "static/media/search-sample-3.12820d3f.png";